import {injectable} from "tsyringe";
import {RenameIssueStatusCommand} from "../commands/rename-issue-status.command";
import {transformer} from "../decorators/transformer.decorator";
import {DataTransferObject} from "../domain/dtos/data-transfer-object.interface";
import {IssueStatus} from "../domain/entities/issue-status.entity";
import {AbstractCommandToDtoTransformer} from "./abstract-command-to-dto.transformer";

@injectable()
@transformer({
    source: RenameIssueStatusCommand,
    target: `dto`
})
export class RenameIssueStatusCommandToDtoTransformer extends AbstractCommandToDtoTransformer<IssueStatus> {

    protected async toDTO(issueStatus: IssueStatus): Promise<DataTransferObject> {
        return {
            uid: issueStatus.uid,
            key: issueStatus.key,
            shortcut: issueStatus.shortcut,
        };
    }
}
